import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { CustomerBankModelType } from '@teinor/erp/types/company/customer/customerBank'
import ModalCECustomerBank from './ModalCECustomerBank'
import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderBoolean, EditRow, DeleteRow } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import ModalDeleteCustomerBank from './ModalDeleteCustomerBank'
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'

interface CustomerBanksProps extends ComponentWithPermissions {
    basicData: CustomerModelType | null
}

const CustomerBanks: React.FC<CustomerBanksProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('banks', 'Bancos'),
        newText: t('addBank', 'Nuevo banco'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableCustomerBanks} CreateModalComponent={ModalCECustomerBank} EditModalComponent={ModalCECustomerBank} DeleteModalComponent={ModalDeleteCustomerBank} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ CustomerId: basicData?.id }} />
    )
}
interface TableCustomerBanksProps extends TableComponentBaseScreenInnerProps {
    className?: string
    name?: string
    hideLoadFiltersButton?: boolean
 }

export const TableCustomerBanks: React.FC<TableCustomerBanksProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams, ...rest }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<CustomerBankModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
            width: 150
        },
        {
            id: 'defaultBank',
            dataKey: 'defaultBank',
            label: t('default', 'Por defecto'),
            width: 150,
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={75} />
        },
        {
            id: 'iban',
            dataKey: 'iban',
            label: t('iban', 'IBAN'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('iban', 'IBAN'), }
            }
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: {
                    items: {
                        'true': { name: t('actived', 'Activados') },
                        'false': { name: t('disabled', 'Desactivados') },
                        'all': { name: t('all', 'Todos') }
                    }, label: t('active', 'Activo')
                }
            },
            searchKey: 'active',
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                const icon = !allRowData?.active ? faRotateLeft : undefined
                return <DeleteRow key={'delete' + parameterValue} {...{ icon, parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        },
    ]
    return (
            <TwinTable columns={columns} name='customerBanks' getDataFrom='/api/app/customer/customerBank/getAllCustomerBanks'  extraWhereParams={extraWhereParams}  onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })} setTableInstance={setTableInstance} {...rest} />
    )
}

export default CustomerBanks